module.exports = __webpack_public_path__ + "img/arrow-up-v2.5df93ef1.svg";